import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { exportInformeMesCsv } from '../../../domain/api/EvbiApi';
import { USER_ID } from '../../../../app/api-client/constants';

export function useExportInformeMes() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const exportar = useCallback(async () => {
    const userId = localStorage.getItem(USER_ID);

    if (!userId) {
      setError('Usuario no autenticado');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const blob = await exportInformeMesCsv(dispatch, userId);

      if (!blob || blob.error) {
        setError('Error al descargar el informe');
        return;
      }

      const fecha = new Date().toISOString().slice(0, 10);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `informe_mes_${fecha}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error al exportar informe mensual:', err);
      setError('Error al descargar el informe');
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  return { exportar, loading, error };
}

export default useExportInformeMes;
